import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CreateResponse,
  FetchManufacturerByIDResponse,
  FetchManufacturersQueryParam,
  FetchManufacturersResponse,
  Manufacturer,
  ManufacturerPayload
} from '@shared/models';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManufacturerService {
  _http = inject(HttpClient);
  _apiUrl = environment.apiUrl;
  _authHeaders = new HttpHeaders({
    Authorization: '',
  });

  createManufacturer(
    manufacturerForm: ManufacturerPayload
  ): Observable<Manufacturer> {
    return this._http
      .post<CreateResponse<Manufacturer>>(
        `${this._apiUrl}/api/manufacturer/register`,
        manufacturerForm,
        { headers: this._authHeaders }
      )
      .pipe(map((resp) => resp.data));
  }

  fetchManufacturers(
    queryParams?: Partial<FetchManufacturersQueryParam>
  ): Observable<FetchManufacturersResponse> {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value) {
          params = params.set(key, value);
        }
      });
    }

    return this._http.get<FetchManufacturersResponse>(
      `${this._apiUrl}/api/manufacturer/list`,
      { headers: this._authHeaders, params }
    );
  }

  updateManufacturer(
    id: number,
    manufacturerForm: ManufacturerPayload
  ): Observable<Manufacturer> {
    return this._http
      .patch<CreateResponse<Manufacturer>>(
        `${this._apiUrl}/api/manufacturer/${id}`,
        manufacturerForm,
        { headers: this._authHeaders }
      )
      .pipe(map((resp) => resp.data));
  }

  public fetchManufacturerById(id: number): Observable<FetchManufacturerByIDResponse> {
    return this._http.get<FetchManufacturerByIDResponse>(
      `${this._apiUrl}/api/manufacturer/${id}`,
      { headers: this._authHeaders }
    );
  }

  deleteManufacturer(id: number) {
    return this._http.delete(
      `${this._apiUrl}/api/manufacturer/${id}`,
      { headers: this._authHeaders }
    )
  }
}
